import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LogoSquareModule } from '@libs/src/logo-square/logo-square.module';

import { WindowNavigationService } from '@main-client/src/app/window-navigation/window-navigation.service';

import { PrivacyComponent } from './privacy.component';

@NgModule({
  imports: [CommonModule, LogoSquareModule],
  exports: [PrivacyComponent],
  declarations: [PrivacyComponent],
  providers: [WindowNavigationService],
})
export class PrivacyModule {}
